import React, { useEffect, useState } from "react";
import { HOME } from "@/constants/testIds";
import { fetchTestimonials } from "@/lib/api";
import { Star, Quotes } from "@phosphor-icons/react";

export default function Testimonials() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    fetchTestimonials().then(setItems).catch(() => setItems([]));
  }, []);

  return (
    <section data-testid={HOME.testimonialsSection} id="testimonials" className="bg-white border-b-2 border-slate-200">
      <div className="mx-auto max-w-7xl px-6 lg:px-8 py-20 lg:py-28">
        <div className="mb-12">
          <div className="text-[11px] font-extrabold tracking-[0.22em] uppercase text-sky-600">
            More from our customers
          </div>
          <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl text-slate-900 mt-3 max-w-2xl leading-tight">
            From contractors, property managers &amp; homeowners.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {items.map((t, idx) => (
            <article
              key={t.id}
              className={`border-2 border-slate-900 p-7 bg-white flex flex-col ${
                idx === 1 ? "md:translate-y-4 bg-slate-50" : ""
              }`}
            >
              <Quotes size={28} weight="fill" className="text-sky-500" />
              <div className="flex gap-1 mt-4">
                {Array.from({ length: t.rating || 5 }).map((_, i) => (
                  <Star key={i} size={16} weight="fill" className="text-amber-500" />
                ))}
              </div>
              <p className="mt-5 text-slate-800 text-base leading-relaxed flex-1">&ldquo;{t.quote}&rdquo;</p>
              <div className="mt-7 pt-5 border-t-2 border-slate-200">
                <div className="font-display font-bold text-slate-900">{t.name}</div>
                <div className="text-xs text-slate-500 mt-0.5">
                  {t.role} · <span className="font-medium">{t.company}</span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
